(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-collage"] && !window.DesignMode) return;
  try {
    
  class HeroProductPins extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
      this.supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    }

    bindEvents() {
      Array.from(this.querySelectorAll('.hero-collage__tooltip-wrapper')).forEach((pin) => {
        console.log(pin.querySelector('a.hero-collage__pin'));
        pin.querySelector('a.hero-collage__pin').addEventListener('click', this.handleClick.bind(this));
        pin.querySelector('a.hero-collage__pin').addEventListener('mouseover', this.hoverElement.bind(this));
        pin.addEventListener('mouseleave', this.mouseLeave.bind(this));
      });
    }

    handleClick(e) {
      if (this.supportsTouch) {
        e.preventDefault();
        if (e.currentTarget.parentNode.classList.contains('active')) {
          e.currentTarget.parentNode.classList.remove('active');
        } else {
          var activePin = document.querySelector('.hero-collage__tooltip-wrapper.active');
          if (activePin) {
            activePin.classList.remove('active');
          }
          e.currentTarget.parentNode.classList.add('active');
        }
      }
    }

    hoverElement(e) {
      if (!this.supportsTouch) {
        e.currentTarget.parentNode.classList.add('active');
      }
    }

    mouseLeave(e) {
      if (!this.supportsTouch) {
        e.currentTarget.classList.remove('active');
      }
    }
  }

  customElements.define('hero-product-pins', HeroProductPins);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    // Style buttons on article pages along the overall button styles
    const articleLinks = document.querySelectorAll('.studioengine .sse-row .sse-column a');
    const articleButtons = Array.from(articleLinks).filter(
      (link) => link.style.backgroundColor && link.style.display == 'inline-block'
    );

    articleButtons.forEach((button) => {
      button.classList.add('button');
      button.style = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
        if (!customElements.get('product-subscription-images')) {
          class ProductSubscriptionImages extends HTMLElement {
            constructor() {
              super();

              // Initialize DOM elements
              this.featuredThumbnailWrapper = document.querySelector('.thumbnail-list .thumbnail');
              this.featuredThumbnail = this.featuredThumbnailWrapper.querySelector('img');
              this.featuredImageWrapper = document.querySelector('.product__media-list .product__media');
              this.featuredImage = this.featuredImageWrapper.querySelector('.product__media-list img');
              this.variantImageWrappers = document.querySelectorAll('.product-form__variant-grid label');
              this.variantImages = document.querySelectorAll('.product-form__input .product-form__variant-image');

              this.subscriptionFeaturedThumbnail = this.querySelector('.product__subscription-featured--thumbnail img');
              this.subscriptionFeaturedImage = this.querySelector('.product__subscription-featured--image img');
              this.subscriptionVariantImages = this.querySelectorAll('.product__subscription-variant-images img');

              const discountOverlay = document.createElement('div');
              discountOverlay.classList.add('product-form__variant-discount-overlay');

              // Add event listener for subscription widget updates
              document.addEventListener('AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated', () => {
                setTimeout(() => {
                  this.appstleOption = document.querySelector('.appstle_subscription_radio_wrapper input');
                  if (this.appstleOption && this.appstleOption.checked) {
                    this.onToggleSubscription(true);
                  } else {
                    this.onToggleSubscription(false);
                  }
                }, 500); // Add delay to ensure DOM is updated
              });
            }

  onToggleSubscription(checked) {
  this.featuredThumbnailWrapper.innerHTML = '';
  this.featuredImageWrapper.innerHTML = '';
// Subscription mode
  if (checked) {
    if (this.subscriptionFeaturedThumbnail) {
      const newThumbnail = this.subscriptionFeaturedThumbnail.cloneNode(true);
      newThumbnail.src = this.subscriptionFeaturedThumbnail.src;
      this.featuredThumbnailWrapper.append(newThumbnail);
    } else {
      console.warn("Subscription thumbnail not found");
    }

    if (this.subscriptionFeaturedImage) {
      const newImage = this.subscriptionFeaturedImage.cloneNode(true);
      newImage.src = this.subscriptionFeaturedImage.src;
      this.featuredImageWrapper.append(newImage);
    } else {
      console.warn("Subscription featured image not found");
    }
//  bundle thumbnail updates
    const bundleThumbnailWrapper = document.querySelector('.bundle-thumbnail'); 
    if (bundleThumbnailWrapper) {
      bundleThumbnailWrapper.innerHTML = '';
      if (this.subscriptionFeaturedThumbnail) {
        const bundleThumbnail = this.subscriptionFeaturedThumbnail.cloneNode(true);
        bundleThumbnail.src = this.subscriptionFeaturedThumbnail.src;
        bundleThumbnailWrapper.append(bundleThumbnail);
      }
    }
  } else {
    // default 
    if (this.featuredThumbnail) {
      const defaultThumbnail = this.featuredThumbnail.cloneNode(true);
      defaultThumbnail.src = this.featuredThumbnail.src;
      this.featuredThumbnailWrapper.append(defaultThumbnail);
    } else {
      console.warn("Default thumbnail not found");
    }

    if (this.featuredImage) {
      const defaultImage = this.featuredImage.cloneNode(true);
      defaultImage.src = this.featuredImage.src;
      this.featuredImageWrapper.append(defaultImage);
    } else {
      console.warn("Default featured image not found");
    }

    //bundle thumbnail updates back
    const bundleThumbnailWrapper = document.querySelector('.bundle-thumbnail');
    if (bundleThumbnailWrapper) {
      bundleThumbnailWrapper.innerHTML = '';
      if (this.featuredThumbnail) {
        const defaultBundleThumbnail = this.featuredThumbnail.cloneNode(true);
        defaultBundleThumbnail.src = this.featuredThumbnail.src;
        bundleThumbnailWrapper.append(defaultBundleThumbnail);
      }
    }
  }
}
          }

          // Define the custom element
          customElements.define('product-subscription-images', ProductSubscriptionImages);
        }
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
